import React from 'react';
import { Table, TableBody, TableCaption, TableCell, TableHead, TableHeader, TableRow } from "@/Components/ui/table";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/Components/ui/accordion";

interface BookingPrice {
    pen_id: number;
    pricing: Pricing;
}

interface Pricing {
    id: number;
    name: string;
    minutes: number;
    from_dogs: number;
    to_dogs: number;
    price: string;
}

interface RateCardProps {
    pricings: BookingPrice[];
    fieldName: string;
}

const RateCard: React.FC<RateCardProps> = ({ pricings, fieldName }) => {
    return (
        <div className='w-full mt-8'>
            <Accordion type="single" collapsible>
                <AccordionItem value="pricing">
                    <AccordionTrigger className="bg-mint px-6 py-4 rounded-lg hover:no-underline hover:bg-mint/90">
                        <h2 className="text-2xl font-bold">{fieldName} Pricing</h2>
                    </AccordionTrigger>
                    <AccordionContent className="pt-6">
                        <div className="w-full rounded shadow bg-white">
                            <Table>
                                <TableHeader>
                                    <TableRow>
                                        <TableHead className='bg-slate-200 text-black rounded font-extrabold'>Session Length</TableHead>
                                        <TableHead className='bg-slate-200 text-black font-extrabold'>Dogs</TableHead>
                                        <TableHead className='bg-slate-200 text-black rounded text-bold text-right'>Price</TableHead>
                                    </TableRow>
                                </TableHeader>
                                <TableBody>
                                    {pricings.map((pricing) => (
                                        <TableRow key={pricing.pricing.id}>
                                            <TableCell className="font-medium">{pricing.pricing.name}</TableCell>
                                            <TableCell>{`${pricing.pricing.from_dogs} to ${pricing.pricing.to_dogs}`} Dogs</TableCell>
                                            <TableCell className="text-right">£{pricing.pricing.price}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                            <p className="mt-4 pb-4 text-sm text-center text-gray-500 italic">
                                These prices may vary on weekends, bank holidays and special times of year.
                            </p>
                        </div>
                    </AccordionContent>
                </AccordionItem>
            </Accordion>
        </div>
    );
};

export default RateCard;
